/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: StaticImageBanner.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  28.11.23 3:41 pm.
 * Last modified: 28.11.23 3:41 pm.
 *
 * More information at: https://egt-digital.com/
 */

import React from 'react';
import { getBrandedStaticImages } from '../../api/helpers';
import { useLobbyHost, useSettings } from '../../contexts/SettingsContext';

const StaticImageBanner = ({ group }: IStaticImageBannerProps) => {
    const host = useLobbyHost();
    const [settings] = useSettings();

    const sectioNameAsArray = (group || '')
        .split('_')
        .join(' ')
        .split(' ');
    if (sectioNameAsArray.length > 1) {
        sectioNameAsArray.splice(0, 1);
    }
    const brand = sectioNameAsArray.join('_').toLowerCase();

    const image = getBrandedStaticImages(group || '', brand, settings.languageCode.toLowerCase(), host);

    return (
        <div className="egt_static_image_banner">
            <img src={image} alt="Static Banner"></img>
        </div>
    );
};

interface IStaticImageBannerProps {
    group?: string;
}

export default StaticImageBanner;
